import React from 'react'

import Button from 'common/Button'
import Card from 'common/Card'
import Input from 'common/Forms/Input'

export default ({ cancelReject, submitting, rejected, resource }) => {
  const disabled = submitting || rejected
  return (
    <Card
      color="primary"
      outline
      className="mb-4"
      bodyClassName="col-lg-10"
      footer={
        !rejected && (
          <div>
            <Button
              type="submit"
              icon="done"
              color="success"
              disabled={submitting}
              loading={submitting}
              className="float-end"
            >
              {resource.Submit}
            </Button>
            <Button color="warning" onClick={cancelReject} disabled={submitting} className="float-start">
              {resource.Cancel}
            </Button>
          </div>
        )
      }
    >
      <Input
        type="textarea"
        name="remarks"
        rules={{ required: resource.Required }}
        label={resource.Remarks}
        formGroup
        horizontal
        labelCol={{ md: 3 }}
        inputCol={{ md: 9 }}
        rows="5"
        disabled={disabled}
      />
    </Card>
  )
}
